
import Select, { SelectItem, SelectProps } from '../components/Select';
import { RequestStatusEnum } from '../common/enums/request-status.enum';

const StatusOptions: SelectItem<string>[] = [
  {
    key: RequestStatusEnum.NEW,
    value: 'Noua'
  },
  {
    key: RequestStatusEnum.IN_PROGRESS,
    value: 'In lucru'
  },
  {
    key: RequestStatusEnum.TO_DELIVER,
    value: 'De generat'
  },
  {
    key: RequestStatusEnum.FINISHED,
    value: 'Finalizat'
  },
];

type RequestStatusSelectProps = Omit<SelectProps<string>, 'options'>;

const RequestStatusSelect = ({ selected, onChange, ...selectProps }: RequestStatusSelectProps) => {
  return (
    <Select
      {...selectProps}
      placeholder={`Status`}
      options={StatusOptions}
      onChange={onChange}
      selected={selected}
    />
  );
};

export default RequestStatusSelect;
